import { notificationWindowSagas } from '@store/notificationWindow/notificationWindow.sagas';
import { all } from 'redux-saga/effects';

import { desktopSagas } from './desktop/sagas';
import { documentsSagas } from './documents/documents.sagas';
import { featureFlagsSagas } from './featureFlags/featureFlags.sagas';
import { integrationsSagas } from './integrations/integrations.sagas';
import { errorsCountRealtimeSagas } from './realtime/errorsCountRealtime.saga';
import { integrationRequestRealtimeSagas } from './realtime/integrationRequestRealtime.saga';
import { sendingRequestRealTimeSagas } from './realtime/SendingRequestRealtime.saga';
import { sendingRealTimeSagas } from './realtime/sendingRealtime.saga';
import { trustedContactRealtimeSagas } from './realtime/trustedContactRealtime.saga';
import { trackingSagas } from './tracking/sagas';
import { uploadDocumentJobsSagas } from './uploadDocuments/sagas';
import { userSagas } from './user/user.sagas';

export function* rootSaga() {
  yield all([
    ...desktopSagas.map((saga) => saga()),
    ...documentsSagas.map((saga) => saga()),
    ...uploadDocumentJobsSagas.map((saga) => saga()),
    ...trackingSagas.map((saga) => saga()),
    featureFlagsSagas(),
    integrationsSagas(),
    notificationWindowSagas(),
    sendingRealTimeSagas(),
    sendingRequestRealTimeSagas(),
    trustedContactRealtimeSagas(),
    integrationRequestRealtimeSagas(),
    errorsCountRealtimeSagas(),
    userSagas(),
  ]);
}
